import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { canViewDashboard } from "@app/_helpers/permission";
import { UserSettingsQuery } from "@timeghost/web-api";

export const projectDashboardPageGuard: CanActivateFn = (route, state) => {
	const user = inject(UserSettingsQuery).getValue();
	const router = inject(Router);
	if (!user.workspace.settings?.["projecthoursEnabled"]) return router.parseUrl("/");
	const perm = canViewDashboard(user);
	if (!perm || !perm.projectPermission) return router.parseUrl("/");
	return true;
};
